(function () {
  angular
    .module('kareo.ui.shared.directives.provider.k-taxonomy-search', [
      'angucomplete-alt',
      'kareo.ui.shared.directives.templates'
    ])
    .component('kTaxonomySearch', {
      bindings: {
        onSelect: '&?', // argument taxonomy - selected taxonomy
        providerSpecialties: '<',
        isReadOnly: '<?'
      },
      controller,
      controllerAs: 'vm',
      require: {
        ngModel: '?ngModel'
      },
      template: require('./k-taxonomy-search.pug')()
    });

  var instanceCount = 0;

  controller.$inject = ['$scope'];
  function controller($scope) {
    const vm = this;

    var specialtyNamesForTaxonomyCodes;

    vm.initialValue = '';

    vm.descriptionFormatter = descriptionFormatter;
    vm.onBlur = onBlur;
    vm.onChange = onChange;
    vm.onFocus = onFocus;
    vm.selectTaxonomy = selectTaxonomy;

    vm.$onInit = init;

    // ------------------------------------------------------------------------

    function init() {
      vm.elementId = 'k-taxonomy-search-' + ++instanceCount;

      makeSpecialtiesMap();
      $scope.$watch('vm.providerSpecialties', makeSpecialtiesMap, true);

      if (vm.ngModel) {
        vm.initialValue = vm.ngModel.$viewValue;

        $scope.$watch('vm.ngModel.$viewValue', (viewValue) => {
          vm.initialValue = viewValue;
          resetInput(viewValue);
        });
      }
    }

    function changeModel(value) {
      if (vm.ngModel) {
        vm.ngModel.$setViewValue(value, 'change');
      }
    }

    function descriptionFormatter(results) {
      angular.forEach(results, (result) => {
        var specialty;
        result.formattedDescription = '';
        if (!!result.classification) {
          result.formattedDescription += result.classification;
        }
        if (!!specialtyNamesForTaxonomyCodes[result.code]) {
          specialty = specialtyNamesForTaxonomyCodes[result.code];
        } else if (result.specialtyName) {
          specialty = result.specialtyName;
        }
        if (specialty) {
          if (result.formattedDescription.length) {
            result.formattedDescription += ' - ';
          }
          result.formattedDescription += specialty;
        }
      });
      return results;
    }

    function makeSpecialtiesMap() {
      specialtyNamesForTaxonomyCodes = {};
      if (!!vm.providerSpecialties) {
        angular.forEach(vm.providerSpecialties, (specialty) => {
          specialtyNamesForTaxonomyCodes[specialty.code] = specialty.name;
        });
      }
    }

    function onBlur() {
      if (vm.ngModel) {
        vm.ngModel.$focused = false;
      }
    }

    function onChange() {
      if (vm.ngModel) {
        // won't commit value to model until selection is made
        changeModel('');
        vm.ngModel.$setDirty();
      }
    }

    function onFocus() {
      if (vm.ngModel) {
        vm.ngModel.$focused = true;
      }
    }

    function resetInput(value) {
      $scope.$broadcast('angucomplete-alt:changeInput', vm.elementId, value);
    }

    function selectTaxonomy(taxonomy) {
      // angucomplete sucks
      if (!taxonomy || !taxonomy.originalObject) {
        return;
      }
      taxonomy = taxonomy.originalObject;
      changeModel(taxonomy.code);
      if (vm.onSelect) {
        vm.onSelect({ taxonomy });
      }
    }
  }
})();
